module.exports = __webpack_public_path__ + "img/wechat.d13e0bce.svg";